module.exports = __webpack_public_path__ + "img/hat.7595d740.png";